module.exports = __webpack_public_path__ + "static/img/rtc-ico-submit.587f32d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/rtc-ico-submit.png
// module id = +dpN
// module chunks = 1